import React from 'react';
import "react-alice-carousel/lib/alice-carousel.css";
import {jssPreset, StylesProvider} from '@mui/styles';
import {ThemeProvider} from "@material-ui/core/styles"
import CustomTheme from "./assets/CustomTheme";
import './assets/fonts/css/fontiran.css'

import {create} from "jss";
import rtl from "jss-rtl";

import {ToolbarComponent} from "./components/ToolbarComponent";
import {StaticPageComponent} from "./components/StaticPageComponent";

import {BrowserRouter, Route, Routes} from "react-router-dom";
import PrivacyTipOutlinedIcon from "@mui/icons-material/PrivacyTipOutlined";
import ReduceCapacityOutlinedIcon from "@mui/icons-material/ReduceCapacityOutlined";

import {aboutUsContent, privacyPolicyContent} from "./Const";
import {OtpComponent} from "./components/OtpComponent";
import {LoginComponent} from "./components/LoginComponent";
import {TransactionComponent} from "./components/TransactionComponent";
import {OrderComponent} from "./components/OrderComponent";
import {GroupListComponent} from "./components/messenger/GroupListComponent";
import ProductProvider from "./components/ProductProvider";
import {CardShopComponent} from "./components/CardShopComponent";
import PaymentProvider from "./components/PaymentProvider";

import {ProfileComponent} from "./components/ProfileComponent";
import AllProductProvider from "./components/AllProductProvider";
import AllMarketProvider from "./components/AllMarketProvider";
import {SearchComponent} from "./components/SearchComponent";
import {OfferComponent} from "./components/OfferComponent";

import ProductListProvider from "./components/ProductListProvider";
import GlobalProvider from "./components/GlobalProvider";
import {OtpMessengerComponent} from "./components/messenger/OtpMessengerComponent";
import {LoginMessengerComponent} from "./components/messenger/LoginMessengerComponent";
import {LotteryComponent} from "./components/LotteryComponent";
import {WinnerComponent} from "./components/WinnerComponent";
import {ChannelListComponent} from "./components/messenger/ChannelListComponent";
import {DialogComponent} from "./components/messenger/DialogComponent";
import {ContactListComponent} from "./components/messenger/ContactListComponent";
import ChatProvider from "./components/messenger/ChatProvider";

const jss = create({
    plugins: [...jssPreset().plugins, rtl()],
});


function App() {

    return (
        <ThemeProvider theme={CustomTheme}>
            <StylesProvider jss={jss}>

                <BrowserRouter>


                    <Routes>


                        <Route path="/verify" element={
                            <OtpComponent/>
                        }/>
                        <Route path="/login" element={
                            <LoginComponent/>
                        }/>

                        <Route path="/messenger/verify" element={
                            <OtpMessengerComponent/>
                        }/>
                        <Route path="/messenger/login" element={
                            <LoginMessengerComponent/>
                        }/>

                        <Route path="/" element={
                            <ToolbarComponent/>

                        }/>
                        <Route path="/privacy-policy" element={
                            <StaticPageComponent title={"قوانین و مقررات"} content={privacyPolicyContent}
                                                 icon={<PrivacyTipOutlinedIcon/>}/>}/>
                        <Route path="/about-us" element={
                            <StaticPageComponent title={"درباره ما"} content={aboutUsContent}
                                                 icon={<ReduceCapacityOutlinedIcon/>}/>
                        }/>
                        <Route path="/transaction" element={
                            <TransactionComponent/>
                        }/>

                        <Route path="/lottery" element={
                            <LotteryComponent/>
                        }/>

                        <Route path="/winners" element={
                            <WinnerComponent/>
                        }/>

                        <Route path="/order" element={
                            <OrderComponent/>
                        }/>

                        <Route path="/market/*" element={
                            <ProductListProvider/>
                        }/>

                        <Route path="/product/*" element={
                            <ProductProvider/>
                        }/>

                        <Route path="/cardShop" element={
                            <CardShopComponent/>
                        }/>
                        {/*https://hamekara.com/payment-result?status=*/}
                        <Route path="/payment-callback" element={
                            <PaymentProvider/>
                        }/>

                        <Route path="/profile" element={
                            <ProfileComponent/>
                        }/>

                        <Route path="/messenger/dialogs" element={
                            <DialogComponent/>
                        }/>

                        <Route path="/messenger/profile" element={
                            <GroupListComponent/>
                        }/>

                        <Route path="/messenger/groups" element={
                            <GroupListComponent/>
                        }/>

                        <Route path="/messenger/channels" element={
                            <ChannelListComponent/>
                        }/>

                        <Route path="/messenger/chat" element={
                            <ChatProvider/>
                        }/>

                        <Route path="/messenger/contacts" element={
                            <ContactListComponent/>
                        }/>

                        <Route path="/search" element={
                            <SearchComponent/>
                        }/>

                        <Route path="/offers" element={
                            <OfferComponent/>
                        }/>

                        <Route path="/product-list/*" element={
                            <AllProductProvider/>
                        }/>

                        <Route path="/market-list/*" element={
                            <AllMarketProvider/>
                        }/>

                        <Route path="/*" element={
                            <GlobalProvider/>
                        }/>
                    </Routes>

                </BrowserRouter>


            </StylesProvider>
        </ThemeProvider>
    );

}


export default App;







